<aside class="rounded-xl shadow-full border border-greyLight p-6 w-full mb-8">

  <!-- 📱 Mobile: active item only + arrow -->
  <div class="md:hidden">
    <div  *ngIf="!isOpen" class="flex justify-center items-center px-4 py-3 border border-orange rounded-xl cursor-pointer">
      <div class="flex items-center gap-3">
        <img [src]="getActiveItem().icon" alt="icon" class="w-6">
        <span class="text-sm font-semibold" transloco="{{ getActiveItem().labelKey }}"></span>
      </div>
    </div>

    <!-- Dropdown options -->
    <ul class="flex flex-col gap-3 mt-3 overflow-hidden transition-all duration-300 ease-in-out"
      [ngClass]="isOpen ? 'max-h-[25rem] opacity-100' : 'max-h-0 opacity-0'">
      <li *ngFor="let item of sidebarItems" [class.router-link-active]="isActive(item.path)">
        <a [routerLink]="item.path" routerLinkActive="bg-grey text-white"
          class="flex px-4 py-2 hover:bg-greyLight rounded-xl gap-3" (click)="isOpen = false"
          [style]="{'--primary-color': isActive(item.path) ? getColor() : '#efefef'}">
          @if (isActive(item.path)) {
          <img [src]="item.iconActive" alt="icon" class="w-6">
          } @else {
          <img [src]="item.icon" alt="icon" class="w-6">
          }
          <span class="text-sm font-semibold" transloco="{{ item.labelKey }}"></span>
        </a>
      </li>
    </ul>

    <div class="flex flex-col items-center px-4 pt-3 cursor-pointer" (click)="toggleMenu()">
      <svg class="w-5 h-5 transition-transform" [class.rotate-180]="isOpen" xmlns="http://www.w3.org/2000/svg"
        fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  <!-- 💻 Desktop: normal list -->
  <ul class="hidden md:flex flex-col gap-5">
    <li *ngFor="let item of sidebarItems" [class.router-link-active]="isActive(item.path)">
      <a [routerLink]="item.path" routerLinkActive="bg-grey text-white"
        class="flex px-9 py-3 hover:bg-greyLight rounded-xl gap-3 hover-primary"
        [style]="{'--primary-color': isActive(item.path) ? getColor() : '#efefef'}">
        @if (isActive(item.path)) {
        <img [src]="item.iconActive" alt="icon" class="w-6">
        } @else {
        <img [src]="item.icon" alt="icon" class="w-6">
        }
        <span class="text-sm font-semibold" transloco="{{ item.labelKey }}"></span>
      </a>
    </li>
  </ul>
</aside>